// ! https://www.newline.co/fullstack-react/articles/Declaratively_loading_JS_libraries/

// * Globalna api spremenljivka, da se ne naloži vedno znova.
let api = {};

function loadScript(cfg) {
	const script = document.createElement('script');

	script.type = 'text/javascript';
	script.async = true;
	script.defer = true;

	const scriptHref = new URL(cfg.baseUrl);
	for (const key in cfg.params) {
		scriptHref.searchParams.append(key, cfg.params[key]);
	}

	script.src = scriptHref.href;
	document.head.appendChild(script);
}

export function apiScriptLoader(cfg) {
	const type = cfg.type;
	return new Promise((resolve, reject) => {
		if (api[type]) return resolve(api[type]);
		try {
			loadScript(cfg);

			window[cfg.callback] = () => {
				api[type] = window[type];
				resolve(api[type]);
			};

			setTimeout(() => {
				if (!window[type]) {
					reject(`Error: could not load the "${type}" API!`);
				}
			}, 5000);
		} catch (error) {
			reject(error);
		}
	});
}
